import { makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  input: {
    margin: `${theme.spacing(2)}px 0 ${theme.spacing(2)}px 0`,
  },
}));

export default useStyles;
